module.exports = __webpack_public_path__ + "img/02.a9d7f506.jpg";